// src/components/EntriesList/utils/dateUtils.js
/**
 * Hilfsfunktionen zur Datumsformatierung und -parsing
 */

/** Hilfsfunktion: Formatiert Datum in TT.MM.JJJJ */
export function formatDateToGerman(dateObj) {
    if (!dateObj) return '';
    const dd = String(dateObj.getDate()).padStart(2, '0');
    const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
    const yyyy = dateObj.getFullYear();
    return `${dd}.${mm}.${yyyy}`;
  }
  
  /** Hilfsfunktion: Parst Datum im Format YYYY-MM-DD */
  export function parseDate(str) {
    if (!str) return null;
    const [yyyy, mm, dd] = str.split('-');
    if (!dd || !mm || !yyyy) return null;
    return new Date(+yyyy, +mm - 1, +dd);
  }